import { useContext } from 'react';
import { PatientIvStatusDialogContext } from './context';

export const usePatientIvStatusDialog = () => {
  const context = useContext(PatientIvStatusDialogContext);

  if (!context) throw new Error('usePatientIvStatusDialog called outside PatientIvStatusDialogContext');

  return context;
};
